import React from 'react';
import { TestResult } from './annotationValidator';
import { ApiResponse } from 'framework/api';
import { observer } from 'mobx-react';
import { Section } from 'controls/react/layout/section';

const getMessages = (result: ApiResponse<TestResult>) => {
	return [
		{
			text: result.message,
			success: result.success,
			glyph: result.success ? 'ok' : 'remove-circle',
		},
		...(result.data?.details ?? [])
			.filter((detail) => detail.message !== result.message)
			.map((detail) => ({
				text: detail.message,
				success: detail.success,
				glyph: detail.success ? 'ok' : 'remove-circle',
			})),
	];
};

export const TestResultsWindow = observer(({ result }: { result: ApiResponse<TestResult> }) => {
	const messages = getMessages(result);
	return (
		<Section contentPadding={true}>
			<ul>
				{messages.map((el, index) => (
					<li key={index}>
						<span>{el.text}</span>
						<span className={`glyphicons cw_error_status ${el.glyph}`}></span>
					</li>
				))}
			</ul>
		</Section>
	);
});
